<template>
    <div class="pr-1">
        <img src="@/assets/svg/edit-3.svg" alt="edit" class="edit" @click="goToUpdatePage">
    </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToUpdatePage () {
      this.$router.push({ path: `/services/${this.$route.params.service_type}/${this.$route.params.id}/${this.$route.params.occupancy_type}/${this.row.id}` })
    }
  }
}
</script>

<style>
    .edit:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/datatable/OccupancyTypeEditButton.vue